<template>
  <div class="tablet-preview">
    <!-- ラベル -->
    <CommonTabletPreviewLabels :is-mind-alte="isMindAlte" />

    <!-- タブレットアイテム -->
    <CommonTabletPreviewItems
      :is-mind-alte="isMindAlte"
      :back-color="backColor"
      :front-color="frontColor"
    >
      <!-- タブレットアイテム裏 -->
      <template slot="item-back">
        <!-- タブレットアイテム裏: カラーサンプル -->
        <CommonTabletPreviewItemsColorSamplesBack
          v-if="type === 'ColorSampleMode'"
          :detail="order.detail"
          :character-color="backColor"
        />

        <!-- タブレットアイテム裏: レイアウト -->
        <CommonTabletPreviewItemsLayoutsBack
          v-if="type !== 'ColorSampleMode' && order.detail && order.detail.layout"
          :detail="order.detail"
          :character-color="backColor"
          @onClickCharacter="$emit('onClickCharacter', $event)"
        />
      </template>

      <!-- タブレットアイテム表 -->
      <template slot="item-front">
        <!-- タブレットアイテム表: カラーサンプル -->
        <CommonTabletPreviewItemsColorSamplesFront
          v-if="type === 'ColorSampleMode'"
          :detail="order.detail"
          :character-color="frontColor"
        />

        <!-- タブレットアイテム表: レイアウト -->
        <CommonTabletPreviewItemsLayoutsFront
          v-if="type !== 'ColorSampleMode' && order.detail && order.detail.layout"
          :detail="order.detail"
          :character-color="frontColor"
          @onClickCharacter="$emit('onClickCharacter', $event)"
        />
      </template>
    </CommonTabletPreviewItems>

    <!-- 文字色 -->
    <CommonTabletPreviewSelectedColors>
      <!-- 文字色裏 -->
      <CommonTabletPreviewSelectedColor
        v-if="!isMindAlte"
        slot="item-back"
        :character-color="backColor"
      />

      <!-- 文字色表 -->
      <CommonTabletPreviewSelectedColor
        slot="item-front"
        :character-color="frontColor"
      />
    </CommonTabletPreviewSelectedColors>

    <!-- その他の情報 -->
    <CommonTabletPreviewDescription
      v-if="isShowDescription"
      :is-adjust-description="isAdjustDescription"
    />
  </div>
</template>

<script>
import CommonTabletPreviewLabels from "@/components/Common/TabletPreview/Labels.vue";
import CommonTabletPreviewItems from "@/components/Common/TabletPreview/Items.vue";
import CommonTabletPreviewItemsColorSamplesBack from "@/components/Common/TabletPreview/Items/ColorSamples/Back.vue";
import CommonTabletPreviewItemsColorSamplesFront from "@/components/Common/TabletPreview/Items/ColorSamples/Front.vue";
import CommonTabletPreviewItemsLayoutsBack from "@/components/Common/TabletPreview/Items/Layouts/Back.vue";
import CommonTabletPreviewItemsLayoutsFront from "@/components/Common/TabletPreview/Items/Layouts/Front.vue";
import CommonTabletPreviewSelectedColors from "@/components/Common/TabletPreview/SelectedColors.vue";
import CommonTabletPreviewSelectedColor from "@/components/Common/TabletPreview/SelectedColor.vue";
import CommonTabletPreviewDescription from "@/components/Common/TabletPreview/Description.vue";

const MIND_ALTE_CATEGORY_ID = "31200";

export default {
  components: {
    CommonTabletPreviewLabels,
    CommonTabletPreviewItems,
    CommonTabletPreviewItemsColorSamplesBack,
    CommonTabletPreviewItemsColorSamplesFront,
    CommonTabletPreviewItemsLayoutsBack,
    CommonTabletPreviewItemsLayoutsFront,
    CommonTabletPreviewSelectedColors,
    CommonTabletPreviewSelectedColor,
    CommonTabletPreviewDescription,
  },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: null,
    },
    isShowDescription: {
      type: Boolean,
      default: false,
    },
    isAdjustDescription: {
      type: Boolean,
      default: false,
    },
    backColor: {
      type: Object,
      default: () => ({ name: "白", colorCode: "white" }),
    },
    frontColor: {
      type: Object,
      default: () => ({ name: "金", colorCode: "yellow" }),
    },
    onClickCharacter: {
      type: Function,
      default: () => {},
    },
  },
  mounted () {},
  data () {
    return {
      centerDialogVisible: false,
    };
  },
  computed: {
    step: {
      get () {
        // console.log(this.$store.state.orderForm.currentStep);
        return this.$store.state.orderForm.currentStep;
      },
    },
    isMindAlte () {
      const { product } = this.order.detail;
      const categoryId = product && product.category ? product.category.id : null;

      return categoryId === MIND_ALTE_CATEGORY_ID;
    },
  },
  watch: {},
  destroyed () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
</style>
